var i4_Validator = {

	isValidString: function(value, parameter) {
		var result = true;

		if (value === undefined || value == "") {
			result = false;
		} else if (parameter.maxLength && value.length > parameter.maxLength) {
			result = false;
		} else if (parameter.minLength && value.length < parameter.minLength) {
			result = false;
		} else {

			if (parameter.disallowWords) {
				$(parameter.disallowWords).each(function(i, item){
					if (value == item) {
						result = false;
						return false;
					}
				});
			}

			if (result && parameter.characterInvalid) {
				$(parameter.characterInvalid).each(function(i, item) {
					if (value.indexOf(item) >= 0) {
						result = false;
						return false;
					}
				});
			}

			if (result && parameter.characterValid) {
				$(value.split('')).each(function(i, item) {
					if (parameter.characterValid.indexOf(item) == -1) {
						result = false;
						return false;
					}
				});
			}

			if (result && parameter.rejectedStartString) {
				$(parameter.rejectedStartString).each(function(i, item) {
					if (value.indexOf(item) === 0) {
						result = false;
						return false;
					}
				});
			}

			if (result && parameter.allowedStartString) {
				result = false;
				$(parameter.allowedStartString).each(function(i, item) {
					if (value.indexOf(item) === 0) {
						result = true;
						return false;
					}
				});
			}

			if (result && parameter.uniqueDomId) {
        const ids = [];
        [].forEach.call(document.querySelectorAll("*"), function(element) {
          if (element.id && ids.indexOf(element.id) == -1) {
            ids.push(element.id);
          }
        });
        if (ids.includes(value)) {
          result = false;
          return false;
        }
      }
		}

		return result;
	}, // i4_Validator.isValidString()

	isValidFile: function(value, parameter) {
		var result = true;

		if (value === undefined || value == "") {
			result = false;
		} else {

			if (parameter.extensions) {
				var ext_valid = false;
				var splitted = value.split(".");
				var ext = splitted[splitted.length-1];

				$(parameter.extensions).each(function(i, item){
					if (ext.toLowerCase() == item.toLowerCase()) {
						ext_valid = true;
						return false;
					}
				});

				if (!ext_valid) {
					result = false;
				}
			}
		}

		return result;
	}, // i4_Validator.isValidFile()

	isValidNumber: function(value, parameter) {
		var result = true;

		// console.log('parameter', parameter);

		if (value === undefined || value == "") {
			result = false;
		} else if(!parameter.allowFloat && !(/^-?\d+$/).test(value)) { // regex: integer
			result = false;
		} else if(parameter.allowFloat && !(/^-?\d*\.?\d+$/).test(value)) { // regex: positive or negative number
			result = false;
		} else if (parameter.max && value > parameter.max) {
			result = false;
		} else if (parameter.min && value < parameter.min) {
			result = false;
		} else {

			if (result && parameter.rejectedValue) {
				$(parameter.rejectedValue).each(function(i, item) {
					if (parseInt(value) === parseInt(item)) {
						result = false;
						return false;
					}
				});
			}

		}

		return result;
	},

	isValidPhone: function(value, parameter) {
		var result = true;

		// console.log('parameter', parameter);

		if (value === undefined || value == "") {
			result = false;
		} else {

			var cleanValue = value.replace(/^[\+]/g, '');
			cleanValue = cleanValue.replace(/[\.\(\)\s\/-]/g, '');

			if (cleanValue.match(/^[0-9]+$/g) == null) {
				result = false;
			} else if (parameter.minLength && cleanValue.length < parameter.minLength) {
				result = false;
			}

		}

		return result;
	},

	isValidEMail: function(value, parameter) {
		var result = true;

		if (value === undefined || value == "") {
			result = false;
		} else if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(value)) { // regex: email
			result = false;
		}

		return result;
	},

	isValidDate: function(value, parameter) {
		var result = true;

		if (value === undefined || value == "") {
			result = false;
		} {

			var check_date = new Date();
			var year = '';
			var month = '';
			var day = '';

			var splitted_en = value.split("-");
			var splitted_de = value.split(".");
			if(splitted_en.length == 3){
				year = splitted_en[0];
				month = splitted_en[1];
				day = splitted_en[2];
			} else if(splitted_de.length == 3){
				year = splitted_de[2];
				month = splitted_de[1];
				day = splitted_de[0];
			}

			check_date = new Date(year, month-1, day);
			if (check_date == 'Invalid Date') {
				result = false;
			}

			if (year == '' || month == '' || day == ''){
				result = false;
			}
			if (month < 1 || month > 12){
				result = false;
			}
			if (year < 1000 || year > 9999){
				result = false;
			}
			if (day > 32){
				result = false;
			}

			var today = new Date();
			if (parameter.future && check_date < today) {
				result = false;
			} else {

				var today_day = today.getDate();
				var today_month = today.getMonth();
				var today_year = today.getFullYear();
				today = new Date(today_year, today_month, today_day);

				if (parameter.notBeforeToday && check_date < today) {
					result = false;
				}

			}

		}

		return result;
	},

	isValidTime: function(value, parameter) {
		var result = true;

		if (value === undefined || value == "") {
			result = false;
		} else {

			var splitted = value.split(":");

			if (splitted.length > 1 && splitted.length < 4) {
				var hour = splitted[0];
				var minutes = splitted[1];
				var seconds = null;
				if (splitted.length == 3) {
					seconds = splitted[2];
				}

				if (hour < 0 || hour > 23 || isNaN(hour)) {
					result = false;
				} else if (minutes.length != 2 || minutes < 0 || minutes > 59 || isNaN(minutes)) {
					result = false;
				} else if (seconds && (seconds.length != 2 || seconds < 0 || seconds > 59 || isNaN(seconds))) {
					result = false;
				}

			} else {
				result = false;
			}

		}

		return result;
	}

};
